import {
  Dashboard,
  Error,
  HistoryEdu,
  Logout,
  People,
  Save,
  WifiTethering,
} from "@mui/icons-material";
import {
  Divider,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Theme,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FC, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "./user-context";

interface DrawerProps {
  close: () => void;
}

export const DrawerContent: FC<DrawerProps> = ({ close }) => {
  const classes = useClass();

  const { firstName, lastName } = useUser();

  const navigate = useNavigate();

  const exit = useCallback(() => {
    sessionStorage.clear();
    navigate("/");
  }, [navigate]);

  return (
    <nav aria-label="main mailbox folders">
      <>
        <Grid container alignItems="center" px={3.5} py={2}>
          <Typography mr={2} variant="h6" fontWeight="bold">
            {firstName} {lastName}
          </Typography>
        </Grid>
        <Divider />
        <List sx={{ padding: 0 }}>
          <Link to="/app/dashboard" className={classes.links}>
            <ListItem onClick={close}>
              <ListItemButton>
                <ListItemIcon>
                  <Dashboard />
                </ListItemIcon>
                <Typography color="text.secondary" variant="subtitle2">
                  Dashboard
                </Typography>
              </ListItemButton>
            </ListItem>
          </Link>
          <Link to="/app/online" className={classes.links}>
            <ListItem onClick={close}>
              <ListItemButton>
                <ListItemIcon>
                  <WifiTethering />
                </ListItemIcon>
                <Typography color="text.secondary" variant="subtitle2">
                  Online
                </Typography>
              </ListItemButton>
            </ListItem>
          </Link>
          <Link to="/app/users" className={classes.links}>
            <ListItem onClick={close}>
              <ListItemButton>
                <ListItemIcon>
                  <People />
                </ListItemIcon>
                <Typography color="text.secondary" variant="subtitle2">
                  Users
                </Typography>
              </ListItemButton>
            </ListItem>
          </Link>
          <Link to="/app/errors" className={classes.links}>
            <ListItem onClick={close}>
              <ListItemButton>
                <ListItemIcon>
                  <Error />
                </ListItemIcon>
                <Typography color="text.secondary" variant="subtitle2">
                  Errors
                </Typography>
              </ListItemButton>
            </ListItem>
          </Link>
          <Link to="/app/logs" className={classes.links}>
            <ListItem onClick={close}>
              <ListItemButton>
                <ListItemIcon>
                  <HistoryEdu />
                </ListItemIcon>
                <Typography color="text.secondary" variant="subtitle2">
                  Logs
                </Typography>
              </ListItemButton>
            </ListItem>
          </Link>
          <Link to="/app/files" className={classes.links}>
            <ListItem onClick={close}>
              <ListItemButton>
                <ListItemIcon>
                  <Save />
                </ListItemIcon>
                <Typography color="text.secondary" variant="subtitle2">
                  Files
                </Typography>
              </ListItemButton>
            </ListItem>
          </Link>
          <ListItem>
            <ListItemButton onClick={exit}>
              <ListItemIcon>
                <Logout />
              </ListItemIcon>
              <Typography color="text.secondary" variant="subtitle2">
                Exit
              </Typography>
            </ListItemButton>
          </ListItem>
        </List>
      </>
    </nav>
  );
};

const useClass = makeStyles((theme: Theme) => ({
  links: {
    textDecoration: "none",
    color: theme.palette.common.black,
    cursor: "pointer",
  },
  accordion: {
    boxShadow: "none !important",
    marginTop: theme.spacing(1),
  },

  accordionHeader: {
    cursor: "pointer",
    padding: `${theme.spacing(0, 3.5)} !important`,
  },
  accordionContent: {
    margin: `${theme.spacing(0)} !important`,
  },
}));
